/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import client from '@/shared/api/axios-client'
import type { PostRecruitmentCreateMutationRequest, PostRecruitmentCreateMutationResponse, PostRecruitmentCreate400 } from '../entities/PostRecruitmentCreate'
import type { RequestConfig, ResponseErrorConfig } from '@/shared/api/axios-client'

function getPostRecruitmentCreateUrl() {
  return `/recruitment/create` as const
}

/**
 * @description Вербовка водителя таксопарка
 * @summary Вербовка водителя таксопарка
 * {@link /recruitment/create}
 */
export async function postRecruitmentCreate(
  data: PostRecruitmentCreateMutationRequest,
  config: Partial<RequestConfig<PostRecruitmentCreateMutationRequest>> & { client?: typeof client } = {},
) {
  const { client: request = client, ...requestConfig } = config

  const res = await request<PostRecruitmentCreateMutationResponse, ResponseErrorConfig<PostRecruitmentCreate400>, PostRecruitmentCreateMutationRequest>({
    method: 'POST',
    url: getPostRecruitmentCreateUrl().toString(),
    data,
    ...requestConfig,
  })
  return res.data
}